import React, { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import './HomePage.css';
import SearchBar from './SearchBar';
import MediaGrid from './MediaGrid';
import Cookies from 'js-cookie';
import PromptStrip from './PromptStrip';
import { addToWatchlist } from './utils';

const DiscoverPage = () => {
  const [visibleMedia, setVisibleMedia] = useState({ movies: [], 'tv-shows': [] });
  const [oldestMedia, setOldestMedia] = useState({ movies: [], 'tv-shows': [] });
  const [shuffledOldest, setShuffledOldest] = useState({ movie: [], tv: [] });
  const [isLoading, setIsLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [hoveredTV, setHoveredTV] = useState(null);
  const [hoveredMovie, setHoveredMovie] = useState(null);
  const [discoverMode, setDiscoverMode] = useState('tv');
  // Removed castData, setCastData
  const [videoData, setVideoData] = useState({});
  const [expandedVideoId, setExpandedVideoId] = useState(null);
  const [noTrailerFound, setNoTrailerFound] = useState({});
  const [fadingItems, setFadingItems] = useState(new Set());
  const username = Cookies.get("username") || 'default';
  const location = useLocation();
  document.title = 'Watch It Buddy';

  const scrollContainer = (direction, containerId) => {
    const container = document.getElementById(containerId);
    if (container) {
      const scrollAmount = 600;
      container.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  const shuffleArray = (array) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const searchQuery = searchParams.get('s');
    const sectionParam = searchParams.get('section');

    if (searchQuery) {
      setSearchTerm(searchQuery);
    }

    if (sectionParam === 'tv' || sectionParam === 'movies') {
      setDiscoverMode(sectionParam);
    }
  }, [location.search]);
  useEffect(() => {
    const storedMoviesList = localStorage.getItem('sortedWatchList-movies');
    const storedTVList = localStorage.getItem('sortedWatchList-tv-shows');

    const parsedMoviesList = storedMoviesList ? JSON.parse(storedMoviesList) : [];
    const parsedTVList = storedTVList ? JSON.parse(storedTVList) : [];

    setVisibleMedia({ movies: parsedMoviesList, 'tv-shows': parsedTVList });

    setIsLoading(false);
  }, [username]);

  useEffect(() => {
    const fetchOldest = async () => {
      try {
        const [moviesRes, tvRes] = await Promise.all([
          fetch('/api/oldest-media?m=movie'),
          fetch('/api/oldest-media?m=tv'),
        ]);
        const movies = await moviesRes.json();
        const tv = await tvRes.json();
        setOldestMedia({
          movie: movies.map(item => item[1]),
          tv: tv.map(item => item[1]),
        });
        setShuffledOldest({
          movie: shuffleArray(movies.map(item => item[1])).slice(0, 100),
          tv: shuffleArray(tv.map(item => item[1])).slice(0, 100),
        });
      } catch (err) {
        console.error("Failed to fetch oldest media:", err);
      }
    };
    fetchOldest();
  }, []);

  // Video fetching is now handled per media on demand (see handleShowTrailerClick)
  // Handles trailer show/hide and fetches video data on demand
  const handleShowTrailerClick = async (media) => {
    const isExpanded = expandedVideoId === media.tmdb_id;
    if (isExpanded) {
      setExpandedVideoId(null); // toggle off
      return;
    }

    // If not already fetched, fetch the trailer
    if (!videoData[media.tmdb_id]) {
      try {
        const tmdbType = media.media_type || (media.first_air_date ? 'tv' : 'movie');
        const res = await fetch(`/api/videos/${tmdbType}/${media.tmdb_id}`);
        const json = await res.json();
        if (!json.videos?.results?.length) {
          setNoTrailerFound(prev => ({ ...prev, [media.tmdb_id]: true }));
        }
        setVideoData(prev => ({
          ...prev,
          [media.tmdb_id]: json.videos?.results || []
        }));
      } catch (err) {
        setNoTrailerFound(prev => ({ ...prev, [media.tmdb_id]: true }));
        console.error("Error fetching video on demand", err);
      }
    }

    setExpandedVideoId(media.tmdb_id);
  };
   
  // Shuffle handler for random sections
  const handleShuffle = (type) => {
    setShuffledOldest(prev => ({
      ...prev,
      [type]: shuffleArray(oldestMedia[type])
    }));
  };

  return (
    <main>
      {/* Top toggle bar from HomePage */}
      <div className="media-toggle-bar" style={{ display: 'flex', paddingTop:"40px",  justifyContent: 'space-between', alignItems: 'center', marginRight: '20px', marginLeft: '20px' }}>
        <div className="media-toggle">
          <button
            className={`media-toggle-button ${discoverMode === 'tv' ? 'active' : ''}`}
            onClick={() => setDiscoverMode('tv')}
          >
            TV
          </button>
          <button
            className={`media-toggle-button ${discoverMode === 'movies' ? 'active' : ''}`}
            onClick={() => setDiscoverMode('movies')}
          >
            Movies
          </button>
        </div>
        <div className="discover-group" style={{ display: 'flex', gap: '10px' }}>
          <a href={`/home?section=${discoverMode}`} className="discover-btn active">Top Picks</a>          
          <a href={`/quick-pick-elimination?m=${discoverMode === 'tv' ? 'tv-shows' : 'movies'}`} className="discover-btn">Watch list</a>
        
        </div>
      </div>
      {/* END Top toggle bar */}      
      <section className="homepage-section" style={{paddingTop: '10px'}}>
        <SearchBar initialSearchTerm={searchTerm} />
      </section>          
      {discoverMode === 'tv' && (
        <>
          <hr style={{borderColor: '#333', margin: '40px 15px 30px'}} />
          <section className="homepage-section">
            <div className="section-header">
              <h2 className="section-title" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <span role="img" aria-label="TV">🖥️</span> Popular TV
              </h2>
            </div>
            {!isLoading && shuffledOldest.tv.slice(10, 20).map((media, index) => {
              const isExpanded = expandedVideoId === media.tmdb_id;
              const noVideo = noTrailerFound[media.tmdb_id];
              const videoButton = (
                <button
                  onClick={() => handleShowTrailerClick(media)}
                  className={`btn ${noVideo ? 'btn-secondary' : 'btn-primary'}`}
                  disabled={noVideo}
                >
                  {noVideo
                    ? 'No Trailer Found'
                    : (isExpanded ? 'Hide Trailer' : 'Show Trailer')}
                </button>
              );
              const handleAddToWatchlist = (media, e) => {
                addToWatchlist(media, e);
                setFadingItems(prev => new Set(prev).add(media.tmdb_id));
                setTimeout(() => {
                  setShuffledOldest(prev => ({
                    ...prev,
                    [media.media_type === 'movie' ? 'movie' : 'tv']: prev[media.media_type === 'movie' ? 'movie' : 'tv'].filter(item => item.tmdb_id !== media.tmdb_id)
                  }));
                  setFadingItems(prev => {
                    const updated = new Set(prev);
                    updated.delete(media.tmdb_id);
                    return updated;
                  });
                }, 400);
              };
              const trailer = expandedVideoId === media.tmdb_id && videoData[media.tmdb_id]?.[0]?.key && (
                <div style={{ marginTop: '10px', width: '100%' }}>
                  <iframe
                    width="100%"
                    height="315"
                    src={`https://www.youtube.com/embed/${videoData[media.tmdb_id][0].key}`}
                    title="Trailer"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                </div>
              );
              return (
                <div
                  className={`list-item ${fadingItems.has(media.tmdb_id) ? 'fade-out' : ''}`}
                  key={index}
                  style={{
                    backgroundImage: `url(${media.full_backdrop_path || media.backdrop_path})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundBlendMode: 'overlay',
                    backgroundColor: '#1a1a1a',
                    borderRadius: '12px',
                    padding: '20px',
                    marginBottom: '40px',
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '20px'
                  }}>
                  <div className="media-no-video">
                    <div className="poster-wrapper" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'relative' }}>
                      <img
                        src={media.full_poster_path || media.poster_path}
                        alt={media.title}
                        style={{ width: '120px', borderRadius: '6px', objectFit: 'cover' }}
                      />
                      <button
                        onClick={(e) => handleAddToWatchlist(media, e)}
                        className="btn btn-secondary"
                        style={{
                          position: 'absolute',
                          bottom: '0px',
                          left: '0',
                          right: '0',
                          width: '100%',
                          backgroundColor: 'rgba(0,0,0,0.6)',
                          borderRadius: '0 0 6px 6px',
                          color: 'white',
                          padding: '10px 0',
                          fontSize: '14px',
                          textAlign: 'center',
                          border: 'none'
                        }}
                      >
                        + WATCHLIST
                      </button>
                    </div>
                    <div className="media-details-wrapper" style={{ flex: 1, color: '#fff' }}>
                      <h3 style={{ margin: '0 0 8px' }}>
                        <a href={media.url} target="_blank" rel="noopener noreferrer" style={{ color: '#61dafb', textDecoration: 'underline' }}>
                          {media.title}
                        </a>
                      </h3>
                      <p style={{ fontSize: '14px', opacity: 0.85 }}>{media.release_date?.split('-')[0]} | {media.genre_names?.join(', ')}</p>
                      <p style={{ fontSize: '15px', marginTop: '10px' }}>{media.overview}</p>
                      <div style={{ display: 'flex', gap: '10px', marginTop: '15px' }}>                                                
                        {videoButton}
                      </div>
                    </div>
                  </div>
                  {trailer}
                </div>
              );
            })}
          </section>
          <hr style={{borderColor: '#333', margin: '40px 15px 30px'}} />
          <section className="homepage-section">
            <div className="section-header">
              <h2
                className="section-title"
                style={{
                  color: '#61dafb',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px'
                }}
                onClick={() => handleShuffle('tv')}
              >
                <i className="fa fa-random" style={{ fontSize: '22px', opacity: 0.7 }} aria-hidden="true"></i> Random TV Shows
              </h2>
            </div>
            {/* Newspaper-style preview layout for Random TV */}
            {!isLoading && shuffledOldest.tv.slice(0, 10).map((media, index) => {
              const isExpanded = expandedVideoId === media.tmdb_id;
              const noVideo = noTrailerFound[media.tmdb_id];
              const videoButton = (
                <button
                  onClick={() => handleShowTrailerClick(media)}
                  className={`btn ${noVideo ? 'btn-secondary' : 'btn-primary'}`}
                  disabled={noVideo}
                >
                  {noVideo
                    ? 'No Trailer Found'
                    : (isExpanded ? 'Hide Trailer' : 'Show Trailer')}
                </button>
              );
              const handleAddToWatchlist = (media, e) => {
                addToWatchlist(media, e);
                setFadingItems(prev => new Set(prev).add(media.tmdb_id));
                setTimeout(() => {
                  setShuffledOldest(prev => ({
                    ...prev,
                    [media.media_type === 'movie' ? 'movie' : 'tv']: prev[media.media_type === 'movie' ? 'movie' : 'tv'].filter(item => item.tmdb_id !== media.tmdb_id)
                  }));
                  setFadingItems(prev => {
                    const updated = new Set(prev);
                    updated.delete(media.tmdb_id);
                    return updated;
                  });
                }, 400);
              };
              const trailer = expandedVideoId === media.tmdb_id && videoData[media.tmdb_id]?.[0]?.key && (
                <div style={{ marginTop: '10px', width: '100%' }}>
                  <iframe
                    width="100%"
                    height="315"
                    src={`https://www.youtube.com/embed/${videoData[media.tmdb_id][0].key}`}
                    title="Trailer"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                </div>
              );
              return (
                <div
                  className={`list-item ${fadingItems.has(media.tmdb_id) ? 'fade-out' : ''}`}
                  key={index}
                  style={{
                    backgroundImage: `url(${media.full_backdrop_path || media.backdrop_path})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundBlendMode: 'overlay',
                    backgroundColor: '#1a1a1a',
                    borderRadius: '12px',
                    padding: '20px',
                    marginBottom: '40px',
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '20px'
                  }}>
                  <div className="media-no-video">
                    <div className="poster-wrapper" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'relative' }}>
                      <img
                        src={media.full_poster_path || media.poster_path}
                        alt={media.title}
                        style={{ width: '120px', borderRadius: '6px', objectFit: 'cover' }}
                      />
                      <button
                        onClick={(e) => handleAddToWatchlist(media, e)}
                        className="btn btn-secondary"
                        style={{
                          position: 'absolute',
                          bottom: '0px',
                          left: '0',
                          right: '0',
                          width: '100%',
                          backgroundColor: 'rgba(0,0,0,0.6)',
                          borderRadius: '0 0 6px 6px',
                          color: 'white',
                          padding: '10px 0',
                          fontSize: '14px',
                          textAlign: 'center',
                          border: 'none'
                        }}
                      >
                        + WATCHLIST
                      </button>
                    </div>
                    <div className="media-details-wrapper" style={{ flex: 1, color: '#fff' }}>
                      <h3 style={{ margin: '0 0 8px' }}>
                        <a href={media.url} target="_blank" rel="noopener noreferrer" style={{ color: '#61dafb', textDecoration: 'underline' }}>
                          {media.title}
                        </a>
                      </h3>
                      <p style={{ fontSize: '14px', opacity: 0.85 }}>{media.release_date?.split('-')[0]} | {media.genre_names?.join(', ')}</p>
                      <p style={{ fontSize: '15px', marginTop: '10px' }}>{media.overview}</p>
                      <div style={{ display: 'flex', gap: '10px', marginTop: '15px' }}>                                                
                        {videoButton}
                      </div>
                    </div>
                  </div>
                  {trailer}
                </div>
              );
            })}
          </section>
        </>
      )}
      {discoverMode === 'movies' && (
        <>
          <hr style={{borderColor: '#333', margin: '40px 15px 30px'}} />
          <section className="homepage-section">
            <div className="section-header">
              <h2 className="section-title" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <span role="img" aria-label="Movies">🎬</span> Popular Movies
              </h2>
            </div>
            {!isLoading && shuffledOldest.movie.slice(10, 20).map((media, index) => {
              const isExpanded = expandedVideoId === media.tmdb_id;
              const noVideo = noTrailerFound[media.tmdb_id];
              const videoButton = (
                <button
                  onClick={() => handleShowTrailerClick(media)}
                  className={`btn ${noVideo ? 'btn-secondary' : 'btn-primary'}`}
                  disabled={noVideo}
                >
                  {noVideo
                    ? 'No Trailer Found'
                    : (isExpanded ? 'Hide Trailer' : 'Show Trailer')}
                </button>
              );
              const handleAddToWatchlist = (media, e) => {
                addToWatchlist(media, e);
                setFadingItems(prev => new Set(prev).add(media.tmdb_id));
                setTimeout(() => {
                  setShuffledOldest(prev => ({
                    ...prev,
                    [media.media_type === 'movie' ? 'movie' : 'tv']: prev[media.media_type === 'movie' ? 'movie' : 'tv'].filter(item => item.tmdb_id !== media.tmdb_id)
                  }));
                  setFadingItems(prev => {
                    const updated = new Set(prev);
                    updated.delete(media.tmdb_id);
                    return updated;
                  });
                }, 400);
              };
              const trailer = expandedVideoId === media.tmdb_id && videoData[media.tmdb_id]?.[0]?.key && (
                <div style={{ marginTop: '10px', width: '100%' }}>
                  <iframe
                    width="100%"
                    height="315"
                    src={`https://www.youtube.com/embed/${videoData[media.tmdb_id][0].key}`}
                    title="Trailer"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                </div>
              );
              return (
                <div
                  className={`list-item ${fadingItems.has(media.tmdb_id) ? 'fade-out' : ''}`}
                  key={index}
                  style={{
                    backgroundImage: `url(${media.full_backdrop_path || media.backdrop_path})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundBlendMode: 'overlay',
                    backgroundColor: '#1a1a1a',
                    borderRadius: '12px',
                    padding: '20px',
                    marginBottom: '40px',
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '20px'
                  }}>
                  <div className="media-no-video">
                    <div className="poster-wrapper" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'relative' }}>
                      <img
                        src={media.full_poster_path || media.poster_path}
                        alt={media.title}
                        style={{ width: '120px', borderRadius: '6px', objectFit: 'cover' }}
                      />
                      <button
                        onClick={(e) => handleAddToWatchlist(media, e)}
                        className="btn btn-secondary"
                        style={{
                          position: 'absolute',
                          bottom: '0px',
                          left: '0',
                          right: '0',
                          width: '100%',
                          backgroundColor: 'rgba(0,0,0,0.6)',
                          borderRadius: '0 0 6px 6px',
                          color: 'white',
                          padding: '10px 0',
                          fontSize: '14px',
                          textAlign: 'center',
                          border: 'none'
                        }}
                      >
                        + Watchlist
                      </button>
                    </div>
                    <div className="media-details-wrapper" style={{ flex: 1, color: '#fff' }}>
                      <h3 style={{ margin: '0 0 8px' }}>
                        <a href={media.url} target="_blank" rel="noopener noreferrer" style={{ color: '#61dafb', textDecoration: 'underline' }}>
                          {media.title}
                        </a>
                      </h3>
                      <p style={{ fontSize: '14px', opacity: 0.85 }}>{media.release_date?.split('-')[0]} | {media.genre_names?.join(', ')}</p>
                      <p style={{ fontSize: '15px', marginTop: '10px' }}>{media.overview}</p>
                      <div style={{ display: 'flex', gap: '10px', marginTop: '15px' }}>                                                
                        {videoButton}
                      </div>
                    </div>
                  </div>
                  {trailer}
                </div>
              );
            })}
          </section>
          <hr style={{borderColor: '#333', margin: '40px 15px 30px'}} />
          <section className="homepage-section">
            <div className="section-header">
              <h2
                className="section-title"
                style={{
                  color: '#61dafb',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px'
                }}
                onClick={() => handleShuffle('movie')}
              >
                <i className="fa fa-random" style={{ fontSize: '22px', opacity: 0.7 }} aria-hidden="true"></i> Random Movies
              </h2>
            </div>
            {/* Newspaper-style preview layout for Random Movies */}
            {!isLoading && shuffledOldest.movie.slice(0, 10).map((media, index) => {
              const isExpanded = expandedVideoId === media.tmdb_id;
              const noVideo = noTrailerFound[media.tmdb_id];
              const videoButton = (
                <button
                  onClick={() => handleShowTrailerClick(media)}
                  className={`btn ${noVideo ? 'btn-secondary' : 'btn-primary'}`}
                  disabled={noVideo}
                >
                  {noVideo
                    ? 'No Trailer Found'
                    : (isExpanded ? 'Hide Trailer' : 'Show Trailer')}
                </button>
              );
              const handleAddToWatchlist = (media, e) => {
                addToWatchlist(media, e);
                setFadingItems(prev => new Set(prev).add(media.tmdb_id));
                setTimeout(() => {
                  setShuffledOldest(prev => ({
                    ...prev,
                    [media.media_type === 'movie' ? 'movie' : 'tv']: prev[media.media_type === 'movie' ? 'movie' : 'tv'].filter(item => item.tmdb_id !== media.tmdb_id)
                  }));
                  setFadingItems(prev => {
                    const updated = new Set(prev);
                    updated.delete(media.tmdb_id);
                    return updated;
                  });
                }, 400);
              };
              const trailer = expandedVideoId === media.tmdb_id && videoData[media.tmdb_id]?.[0]?.key && (
                <div style={{ marginTop: '10px', width: '100%' }}>
                  <iframe
                    width="100%"
                    height="315"
                    src={`https://www.youtube.com/embed/${videoData[media.tmdb_id][0].key}`}
                    title="Trailer"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                </div>
              );
              return (
                <div
                  className={`list-item ${fadingItems.has(media.tmdb_id) ? 'fade-out' : ''}`}
                  key={index}
                  style={{
                    backgroundImage: `url(${media.full_backdrop_path || media.backdrop_path})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundBlendMode: 'overlay',
                    backgroundColor: '#1a1a1a',
                    borderRadius: '12px',
                    padding: '20px',
                    marginBottom: '40px',
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '20px'
                  }}>
                  <div className="media-no-video">
                    <div className="poster-wrapper" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <img
                        src={media.full_poster_path || media.poster_path}
                        alt={media.title}
                        style={{ width: '120px', borderRadius: '6px', objectFit: 'cover' }}
                      />
                    </div>
                    <div className="media-details-wrapper" style={{ flex: 1, color: '#fff' }}>
                      <h3 style={{ margin: '0 0 8px' }}>
                        <a href={media.url} target="_blank" rel="noopener noreferrer" style={{ color: '#61dafb', textDecoration: 'underline' }}>
                          {media.title} 
                        </a>
                      </h3>
                      <p style={{ fontSize: '14px', opacity: 0.85 }}>{media.release_date?.split('-')[0]} | {media.genre_names?.join(', ')}</p>
                      <p style={{ fontSize: '15px', marginTop: '10px' }}>{media.overview}</p>
                      <div style={{ display: 'flex', gap: '10px', marginTop: '15px' }}>                                                
                        {videoButton}
                      </div>
                    </div>
                  </div>
                  {trailer}
                </div>
              );
            })}
          </section>
        </>
      )}
    </main>
  );
};
const handleQuickPickSelection = (type) => {
  window.location.href = `/quick-pick?m=${type}`;
};

// Fade-out CSS for animation (can be moved to CSS file)
const style = document.createElement('style');
style.innerHTML = `
.fade-out {
  opacity: 0;
  transition: opacity 0.4s ease-out;
}
`;
if (!document.head.querySelector('style[data-fadeout]')) {
  style.setAttribute('data-fadeout', 'true');
  document.head.appendChild(style);
}

export default DiscoverPage;
